import { useContext } from 'react';
import BrandContext from './BrandContext';
import * as brands from './brands';
export default function useBrand() {
  const brand = useContext(BrandContext);
  function isBrand(key) {
    return brand === key;
  }
  return {
    brand,
    brands,
    isBrand
  };
}